<template>
    <div class="h-100">
        <div class="nav-left-container h-100">
            <button class="btn nav-button-collapse"
                    ref="navButton"
                    @click="toggleNav">
                <fa :class="(mobileNavShow ? 'fa-chevron-down' : 'fa-bars') + ' text-light'"></fa>
            </button>
            <div :class="'nav-left' + (mobileNavShow ? ' show' : '')"
                 ref="navLeft">
                <div v-if="companies.length > 1"
                     class="d-flex justify-content-end justify-content-md-start">
                    <fa class="fa-building fs-6 ms-3 ps-1 my-1 py-2 text-light"></fa>
                    <drop-down-list v-model="selectedCompanyId"
                                    :list="companies"
                                    class="start-0 w-100"
                                    title="Select Company"></drop-down-list>
                </div>
                <div v-if="companies.length === 1"
                     class="current-company-name nav-link p-2"
                     :title="companies[0].name">
                    <fa class="fa-building ms-2"></fa>
                    {{ companies[0].name }}
                </div>
                <ul v-if="selectedCompanyId"
                    class="nav flex-column" role="tablist">
                    <li v-if="hasInbox"
                        class="nav-item" role="presentation">
                        <button id="inbox-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#inbox"
                                role="tab"
                                aria-controls="inbox"
                                title="Inbox"
                                @click="selectTab($event)"
                                ref="inboxTab">
                            <fa class="fa-envelope"></fa>
                            Inbox
                            <span v-if="callConfigs.length === 1 && selectedInbox?.unreadCount"
                                  class="badge text-bg-danger float-end"
                                  :title="selectedInbox?.unreadCount + ' Unread'">
                                {{ selectedInbox.unreadCount > 9 ? '9+' : selectedInbox.unreadCount }}
                            </span>
                        </button>
                        <ul v-if="inboxes.length > 1"
                            class="nav flex-column" role="tablist">
                            <li v-for="location in inboxes" :key="location.id"
                                class="nav-item" role="presentation">
                                <button class="nav-link"
                                        data-bs-toggle="tab"
                                        data-bs-target="#inbox"
                                        role="tab"
                                        aria-controls="inbox"
                                        :id="location.id"
                                        :title="'Inbox - ' + (location.inboxName || location.locationNameShort || location.locationName)"
                                        @click="selectTab($event, location)">
                                    <fa class="fa-folder-closed"></fa>
                                    <fa class="fa-folder-open"></fa>
                                    {{ location.inboxName || location.locationNameShort || location.locationName }}

                                    <span v-if="location.unreadCount"
                                          class="badge text-bg-danger float-end"
                                          :title="location.unreadCount + ' Unread'">
                                        {{ location.unreadCount > 9 ? '9+' : location.unreadCount }}
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="callConfigs-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#callConfigs"
                                role="tab"
                                aria-controls="callConfigs"
                                title="Locations"
                                @click="selectTab($event)"
                                ref="callConfigsTab">
                            <fa class="fa-location-dot"></fa>
                            Locations
                        </button>
                    </li>
                    <li v-if="isCompanyAdmin()"
                        class="nav-item" role="presentation">
                        <button id="company-users-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#company-users"
                                role="tab"
                                aria-controls="company-users"
                                title="Users"
                                @click="selectTab($event)">
                            <fa class="fa-user"></fa>
                            Users
                        </button>
                    </li>
                    <li v-show="isBillingAdmin()"
                        class="nav-item" role="presentation">
                        <button id="billing-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#billing"
                                role="tab"
                                aria-controls="billing"
                                title="Billing"
                                @click="selectTab($event)"
                                ref="billingTab">
                            <fa class="fa-money-check-dollar"></fa>
                            Billing
                        </button>
                    </li>
                    <feedback-dialog class="nav-item" role="presentation"></feedback-dialog>
                </ul>
            </div>
            <div class="nav-left-body">
                <div v-if="selectedCompanyId"
                     class="tab-content">
                    <div id="inbox" class="tab-pane h-100" role="tabpanel" aria-labelledby="inbox-tab">
                        <div v-if="inboxes.length === 0 && !loading"
                             class="well">
                            <p class="alert alert-warning m-auto w-md-50">
                                You don't have any locations provisioned for {{ company.name }}.
                            </p>
                        </div>
                        <div v-show="inboxes.length"
                             class="d-flex flex-row h-100"
                             :data-time="time">
                            <div :class="{'inbox-left': true, show: !selectedThread?.callSid}">
                                <div v-show="selectedInbox" class="inbox-tools mb-1 px-1">
                                    <input class="form-control flex-column flex-grow-1"
                                           incremental type="search" maxlength="100"
                                           v-model="inboxFilter"
                                           placeholder="🔍 Search inbox"
                                           @search="searchInbox"
                                           v-show="!(selectedInbox?.featureGroupChat)" />
                                    <input class="form-control flex-column flex-grow-1"
                                           incremental type="search" maxlength="100"
                                           v-model="groupMembersFilter"
                                           :placeholder="'🔍 ' + selectedInbox?.locationName"
                                           @search="searchGroupChat"
                                           v-show="selectedInbox?.featureGroupChat" />
                                    <a :class="{'btn ms-1': true, 'text-danger': notifications, 'text-secondary': !notifications }"
                                       :title="notifications ? 'Notifications On' : 'Notifications Off'"
                                       @click.prevent="notifications = !notifications"
                                       tabindex="0" role="button">
                                        <fa v-if="notifications" class="fa-fw fa-bell"></fa>
                                        <fa v-if="!notifications" class="fa-fw fa-bell-slash"></fa>
                                    </a>
                                    <a v-if="selectedInbox?.answerMode === false"
                                       tabindex="0" role="button"
                                       ref="answerModeToggle"
                                       class="btn btn-primary active ms-1" title="Automatic mode"
                                       @click.prevent="toggleAnswerMode">
                                        <fa class="fa-robot"></fa>
                                    </a>
                                    <a v-if="selectedInbox?.answerMode"
                                       tabindex="0" role="button"
                                       ref="answerModeToggle"
                                       class="btn btn-outline-secondary ms-1" title="Assisted mode"
                                       @click.prevent="toggleAnswerMode">
                                        <fa class="fa-user-check"></fa>
                                    </a>
                                </div>
                                <div v-show="!selectedInbox && !loading" class="inbox-list px-1">
                                    <p class="alert alert-info m-4">
                                        No inbox is selected
                                    </p>
                                </div>
                                <div v-show="selectedInbox?.featureGroupChat" class="inbox-list">
                                    <div class="list-group list-group-flush">
                                        <div class="list-group-item fw-bold text-start">
                                            Group Members
                                            <a href="" class="btn btn-sm btn-success float-end rounded-pill"
                                               @click.prevent="showAddGroupMember">
                                                <fa class="fa-plus"></fa> Add Member
                                            </a>
                                        </div>
                                        <div v-for="member in groupMembers" :key="member.id"
                                             class="list-group-item d-flex flex-row text-start px-3 user-select-none">
                                            <div class="flex-column flex-grow-1">
                                                <span class="fw-semibold">{{ member.name }}</span>
                                                <a href="" class="badge bg-primary ms-2 text-light"
                                                   title="Toggle Owner"
                                                   v-show="member.isOwner"
                                                   @click.prevent="toggleGroupMemberOwner(member)">Owner</a>
                                                <a href="" class="badge bg-dark bg-opacity-50 ms-2 text-light"
                                                   title="Toggle Owner"
                                                   v-show="!member.isOwner"
                                                   @click.prevent="toggleGroupMemberOwner(member)">Member</a>
                                                <br /><span>{{ Formatters.phoneNumber(member.phoneNumber) }}</span>
                                            </div>
                                            <div class="flex-column ms-2">
                                                <div class="flex-row">
                                                    <a href=""
                                                       :class="{'badge rounded-pill text-light': true, 'bg-dark bg-opacity-50': !member.enabled, 'bg-success': member.enabled}"
                                                       @click.prevent="toggleGroupMemberEnabled(member)"
                                                       :title="member.enabled ? 'Text messages enabled' : 'Text messages paused'">
                                                        <fa :class="member.enabled ? 'fa-check fa-fw' : 'fa-pause fa-fw'"></fa>
                                                        {{ member.enabled ? 'Enabled' : 'Paused' }}
                                                    </a>
                                                    <a href="" class="ms-2"
                                                       @click.prevent="showDeleteGroupMember(member)"
                                                       title="Remove">
                                                        <fa class="fa-circle-minus fa-lg text-danger"></fa>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="selectedInbox && !selectedInbox?.featureGroupChat" :class="{'inbox-list': true, show: !selectedThread?.callSid}">
                                    <div class="list-group list-group-flush">
                                        <p v-if="!threads.length && inboxFilter && !loading" class="alert alert-info m-4">
                                            No SMS or web chat conversations matched your search
                                        </p>
                                        <p v-if="!threads.length && !inboxFilter && !loading" class="alert alert-info m-4">
                                            No SMS or web chat conversations to show
                                        </p>
                                        <button v-for="thread in threads" :key="thread.id"
                                                :class="{'list-group-item list-group-item-action text-start ps-2': true, active: selectedThread?.callSid === thread.callSid}"
                                                @click="selectThread(thread)"
                                                :aria-current="selectedThread?.callSid === thread.callSid">
                                            <div class="d-flex flex-row">
                                                <div class="d-flex flex-column me-2">
                                                    <fa :class="'fa-xs fa-circle my-auto text-primary' + (thread.unread ? '' : ' invisible')" title="Unread"></fa>
                                                </div>
                                                <div class="d-flex flex-column flex-grow-1 overflow-hidden">
                                                    <div class="d-flex flex-row">
                                                        <div class="flex-grow-1 text-truncate text-bold">
                                                            <fa v-if="thread.callSource === 1" class="fa-sms" title="SMS"></fa>
                                                            <fa v-if="thread.callSource === 2" class="fa-comments" title="Web chat"></fa>
                                                            {{ Formatters.phoneNumber(thread.from) }}
                                                        </div>
                                                        <div class="small text-end text-nowrap">
                                                            {{ relativeDateTime(thread.time) }}
                                                            <span v-if="callConfigs.length > 1">
                                                                <br />{{ Formatters.phoneNumber(thread.to) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="text-truncate inbox-text">
                                                        {{ thread.text }}
                                                    </div>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedThread?.callSid"
                                 class="d-flex flex-column flex-grow-1 inbox-chat-view">
                                <iframe :src="`/webchat/assist/?sid=${selectedThread?.callSid}&theme=${chatTheme}&lang=en-US`"
                                        class="h-100"></iframe>
                                <a class="btn btn-back bg-light bg-opacity-50 d-inline d-sm-none position-absolute" @click.prevent="selectedThread = null"><fa class="fa-arrow-left"></fa></a>
                            </div>
                        </div>
                    </div>
                    <div id="callConfigs" class="tab-pane" role="tabpanel" aria-labelledby="callConfigs-tab">
                        <div v-if="callConfigs.length == 0 && !loading"
                             class="well">
                            <p class="alert alert-warning m-auto w-md-50">
                                You don't have any locations provisioned for {{ company.name }}.
                            </p>
                        </div>

                        <div v-show="callConfigs.length" class="table-responsive datagrid">
                            <table :class="`table ${tableClass} text-start`">
                                <thead>
                                    <tr>
                                        <th>Location</th>
                                        <th>Number</th>
                                        <th>AI Name</th>
                                        <th class="text-end">Count</th>
                                        <th class="w-0"></th>
                                    </tr>
                                </thead>
                                <tbody style="cursor:pointer">
                                    <tr v-for="phone in callConfigs" :key="phone.id" @click="onCallConfigSelected(phone)" :class="{active: selectedCallConfig?.id == phone.id}">
                                        <td>{{ phone.locationName }}</td>
                                        <td><div class="mb-1" v-for="n in phone.numbers" :key="n.id">{{ phoneNumber(n) }}</div></td>
                                        <td>{{ phone.aiName }}</td>
                                        <td class="text-end">{{ phone.callCount }}</td>
                                        <td>
                                            <div class="btn-group">
                                                <a v-if="phone.webChatEnabled" href="" title="Embed Webchat"
                                                   @click.prevent="showEmbedDialog(phone)" class="btn btn-sm btn-outline-secondary text-primary">
                                                    <fa class="fa-code"></fa>
                                                </a>
                                                <a v-if="phone.webChatEnabled"
                                                   :href="'/webchat/advisor/' + phone.id"
                                                   target="_blank"
                                                   title="Advisor Webchat"
                                                   class="btn btn-sm btn-outline-secondary text-white">
                                                    <fa class="fa-comments"></fa>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <ul v-show="selectedCallConfig"
                            class="nav nav-tabs justify-content-end justify-content-md-center mb-4" role="tablist">
                            <li v-if="isOwner()" class="nav-item" role="presentation">
                                <button id="callConfigNumbers-tab"
                                        class="nav-link active"
                                        data-bs-toggle="tab"
                                        data-bs-target="#callConfigNumbers"
                                        role="tab"
                                        aria-controls="callConfigNumbers"
                                        aria-selected="true">
                                    Phone Numbers
                                </button>
                            </li>
                            <li v-if="isOwner()" class="nav-item" role="presentation">
                                <button id="callConfigSettings-tab"
                                        class="nav-link active"
                                        data-bs-toggle="tab"
                                        data-bs-target="#callConfigSettings"
                                        role="tab"
                                        aria-controls="callConfigSettings">
                                    Settings
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button id="callLogs-tab"
                                        class="nav-link active"
                                        data-bs-toggle="tab"
                                        data-bs-target="#callLogs"
                                        role="tab"
                                        aria-controls="callLogs">
                                    Chat Logs
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button id="trainingData-tab"
                                        class="nav-link"
                                        data-bs-toggle="tab"
                                        data-bs-target="#trainingData"
                                        role="tab"
                                        aria-controls="trainingData">
                                    Training Data
                                </button>
                            </li>
                        </ul>

                        <div v-if="selectedCallConfig" class="tab-content">
                            <div v-if="isOwner()" id="callConfigNumbers" class="tab-pane" role="tabpanel" arial-labelledby="callConfigNumbers-tab">
                                <call-config-numbers ref="callConfigNumbersForm"
                                                     :call-config="selectedCallConfig"
                                                     :loading="loading"
                                                     :errors="callConfigNumbersErrors"
                                                     @update="saveNumbers"></call-config-numbers>
                            </div>
                            <div v-if="isOwner()" id="callConfigSettings" class="tab-pane" role="tabpanel" arial-labelledby="callConfigSettings-tab">
                                <call-config-settings ref="callConfigSettingsForm"
                                                      :call-config="selectedCallConfig"
                                                      :loading="loading"
                                                      :errors="callConfigSettingsErrors"
                                                      @update="saveSettings"></call-config-settings>
                            </div>
                            <div id="callLogs" class="tab-pane" role="tabpanel" aria-labelledby="callLogs-tab">
                                <data-grid ref="callLogDataGrid"
                                           :dataendpoint="CallLog.endpoint"
                                           descriptor="callSid"
                                           :show-advanced="false"
                                           :columns="CallLog.columns"
                                           :filter="{ callConfigId: selectedCallConfig?.id, minSize: 2 }"
                                           :tool-add="false"
                                           :tool-delete="false"
                                           :tool-edit="false"
                                           title="Call Log"
                                           defaultsort="createdAt"
                                           defaultsortDir="desc"
                                           @onselected="onCallLogSelected"></data-grid>
                                <chat-view v-if="selectedCallLogId"
                                           :messages="messages"
                                           @retrain="retrain"></chat-view>
                            </div>
                            <div id="trainingData" class="tab-pane" role="tabpanel" aria-labelledby="trainingData-tab">
                                <data-grid ref="trainingDataGrid"
                                           :dataendpoint="TrainingData.endpoint"
                                           :show-advanced="false"
                                           :show-import="true"
                                           :show-export="true"
                                           modal-size="modal-lg"
                                           title="Training Data"
                                           :pagingcontrols="false"
                                           :columns="TrainingData.columns"
                                           :custom-tools="TrainingData.tools"
                                           :filter="{ callConfigId: selectedCallConfig?.id }"></data-grid>
                            </div>
                        </div>
                    </div>

                    <div id="company-users" class="tab-pane" role="tabpanel" aria-labelledby="company-users-tab">
                        <data-grid :dataendpoint="AppUser.endpoint"
                                   :show-advanced="false"
                                   :columns="AppUser.columns"
                                   :selectable="false"
                                   descriptor="userName"
                                   defaultsort="userName"
                                   defaultsortDir="desc"
                                   :tool-add="true"
                                   :tool-delete="true"
                                   @url="companyUserUrl"
                                   :customTools="AppUser.tools"
                                   title="User"
                                   :filter="{ companyId: selectedCompanyId }"></data-grid>
                    </div>

                    <div id="billing" class="tab-pane" role="tabpanel" aria-labelledby="billing-tab">
                        <div class="m-auto w-md-50 text-start">
                            <div class="row border border-default br-10 mb-4 p-2">
                                <div class="col-6">
                                    <dl>
                                        <dt>Business information</dt>
                                        <dd v-html="infoBlock(businessInfo)"></dd>
                                    </dl>
                                </div>
                                <div class="col-6 text-end small">
                                    <a href="#" @click.prevent="editBusiness">
                                        Edit business information
                                    </a>
                                </div>
                            </div>
                            <div class="row border border-default br-10 mb-4 p-2">
                                <div class="col-6">
                                    <dl>
                                        <dt>Billing information</dt>
                                        <dd v-html="infoBlock(billingInfo)"></dd>
                                    </dl>
                                </div>
                                <div class="col-6 text-end small">
                                    <a href="#" @click.prevent="editBilling">
                                        Edit billing information
                                    </a>
                                </div>
                            </div>
                            <div class="row border border-default br-10 mb-4 p-2">
                                <div class="col-6">
                                    <dl>
                                        <dt>Payment method</dt>
                                        <dd v-html="paymentMethodDescription"></dd>
                                    </dl>
                                </div>
                                <div class="col-6 text-end small">
                                    <a href="#" @click.prevent="editPayment">
                                        Edit payment method
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade"
             id="editBillingModal"
             ref="editBillingModal"
             data-bs-backdrop="static"
             data-bs-keyboard="true"
             tabindex="-1"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content text-dark text-start">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Billing Information</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                    </div>
                    <div class="modal-body">
                        <auto-form ref="editBillingForm" :columns="BillingInfo.columns" :loading="loading"></auto-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-bs-dismiss="modal" :disabled="loading"> Cancel </button>
                        <button type="button" class="btn btn-primary" @click="submitBilling" :disabled="loading"> Save </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade"
             id="editBusinessModal"
             ref="editBusinessModal"
             data-bs-backdrop="static"
             data-bs-keyboard="true"
             tabindex="-1"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content text-dark text-start">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Business Information</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                    </div>
                    <div class="modal-body">
                        <auto-form ref="editBusinessForm" :columns="BillingInfo.columns" :loading="loading"></auto-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-bs-dismiss="modal" :disabled="loading"> Cancel </button>
                        <button type="button" class="btn btn-primary" @click="submitBusiness" :disabled="loading"> Save </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade"
             id="editPaymentModal"
             ref="editPaymentModal"
             data-bs-backdrop="static"
             data-bs-keyboard="true"
             tabindex="-1"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content text-dark text-start">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Payment Method</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                    </div>
                    <div class="modal-body">
                        <auto-form ref="editPaymentForm" :columns="PaymentMethod.columns" :loading="loading"></auto-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-bs-dismiss="modal" :disabled="loading"> Cancel </button>
                        <button type="button" class="btn btn-primary" @click="submitPayment" :disabled="loading"> Save </button>
                    </div>
                </div>
            </div>
        </div>
        <common-dialog ref="dialog"></common-dialog>

        <common-dialog ref="addGroupMemberDialog" title="Add Group Member"
                       @ok="addGroupMember">
            <template #body>
                <auto-form ref="addGroupMemberForm" :columns="GroupMember.columns" :loading="loading"></auto-form>
            </template>
        </common-dialog>

        <common-dialog ref="embedDialog" title="Embed Webchat">
            <template #body>
                <div class="position-relative">
                    <p>Add this code to the bottom of your webpage to embed the web chat widget.</p>
                    <p class="border border-2 border-primary font-monospace p-2 small" v-html="embedCode" style="border-radius:6px"></p>
                    <button @click="copyEmbed" class="btn" style="position:absolute;right:0;bottom:0"
                            title="Copy code">
                        <i class="fa fa-copy"></i>
                    </button>
                </div>
                <div class="form-inline my-2">
                    <div class="row">
                        <div class="col-3 text-center">
                            <div class="form-label">Theme&nbsp;</div>
                            <a href="" class="btn" @click.prevent="embedTheme = (embedTheme === 1 ? 2 : 1)"
                               title="Theme">
                                <i :class="'fa fa-lg fa-toggle-'+(embedTheme === 1 ? 'off' : 'on')"></i>
                                {{ embedTheme === 2 ? 'Dark' : 'Light' }}
                            </a>
                        </div>
                        <div class="col-3 text-center">
                            <div class="form-label">Start&nbsp;Open</div>
                            <a href="" class="btn" @click.prevent="embedOpen = (embedOpen === 1 ? 0 : 1)"
                               title="Theme">
                                <i :class="'fa fa-lg fa-toggle-'+(embedOpen === 1 ? 'on' : 'off')"></i>
                                {{ embedOpen ? 'Yes' : 'No' }}
                            </a>
                        </div>
                        <div class="col-3 text-center">
                            <div class="form-label">Color&nbsp;</div>
                            <input type="color" v-model="embedColor1" class="btn form-control-color w-75" />
                        </div>
                        <div class="col-3 text-center">
                            <div class="form-label">Accent&nbsp;</div>
                            <input type="color" v-model="embedColor2" class="btn form-control-color w-75" />
                        </div>
                    </div>
                </div>
            </template>
        </common-dialog>
    </div>
</template>
<script>
    import * as signalR from '@microsoft/signalr';
    import axios from 'axios';
    import AutoForm from '../components/DataGrid/AutoForm';
    import CallConfigNumbers from '../components/Dashboard/CallConfigNumbers';
    import CallConfigSettings from '../components/Dashboard/CallConfigSettings';
    import ChatView from '../components/ChatView';
    import CommonDialog from '../components/Dialog/CommonDialog';
    import FeedbackDialog from '../components/Dialog/FeedbackDialog';
    import { debounce } from '../common/debounce';
    import DataGrid from '../components/DataGrid/DataGrid';
    import DropDownList from '../components/DropDown/DropDownList';
    import { Formatters } from '../common/formatters';
    import { PickList } from '../components/DataGrid/AutoForm';
    import Prefs from '../common/preferences';
    import qs from 'qs';

    const datetime = 'datetime';
    const inGrid = ['grid'];
    const notification = new Audio('https://files.fumbl.ai/public/audio/notification.ogg');

    export default {
        props: {
            companies: {
                type: Array
            }
        },
        components: {
            AutoForm,
            CallConfigNumbers,
            CallConfigSettings,
            ChatView,
            CommonDialog,
            DataGrid,
            DropDownList,
            FeedbackDialog,
        },
        data: function () {
            return {
                Formatters,
                billingInfo: {
                    id: null,
                    companyId: null,
                    name: null,
                    description: null,
                    contactPhone: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zip: null,
                    country: null,
                },
                businessInfo: {
                    id: null,
                    name: null,
                    description: null,
                    contactPhone: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zip: null,
                    country: null,
                },
                paymentMethod: {
                    name: null,
                    cardNumber: null,
                    expiration: null,
                    cvv: null,
                    billingZip: null,
                },
                callConfigs: [],
                callConfigNumbersErrors: {},
                callConfigSettingsErrors: {},
                company: {},
                connected: false,
                currentUser: {
                    userId: null,
                    name: '',
                    roles: {},
                },
                embed: {},
                embedColor1: '#1c59b5',
                embedColor2: '#ffffff',
                embedOpen: 0,
                embedTheme: 1,
                groupMembers: [],
                groupMembersFilter: '',
                inboxFilter: '',
                loading: true,
                mobileNavShow: false,
                messages: [],
                notifications: true,
                selectedInbox: null,
                selectedCallConfig: null,
                selectedCallLogId: null,
                selectedCompanyId: null,
                selectedThread: null,
                threads: [],
                time: new Date().getTime(),
                title: '',
                AppUser: {
                    endpoint: '/users',
                    columns: [
                        {
                            name: 'userName',
                            label: 'Username',
                            editable: false,
                        }, {
                            name: 'firstName',
                            label: 'First name',
                        }, {
                            name: 'lastName',
                            label: 'Last name',
                        }, {
                            name: 'primaryEmail',
                            label: 'Primary Email',
                            editable: (_, m) => !m.id,
                        }, {
                            name: 'cellPhone',
                            label: 'Mobile phone',
                            editable: (_, m) => !m.id,
                        }, {
                            name: 'companyRoles',
                            label: 'Roles',
                            type: 'multiselect',
                            options: [{ label: 'Owner', value: 'Owner' }, { label: 'Company Admin', value: 'CompanyAdmin' }, { label: 'Billing Admin', value: 'BillingAdmin' }],
                            showValue: false,
                            showOnFocus: true,
                            sortable: false,
                            strings: true, //just use the string values, not the objects
                            formatter(value) { return Formatters.stringArrayFormatter(value?.map(s => s.replace(/(\p{Lu})/gu, ' $&'))); },
                        }
                    ]
                },
                BillingInfo: {
                    endpoint: '/companies/billing/',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name',
                            required: true,
                        }, {
                            name: 'description',
                            label: 'Description',
                            required: true,
                        }, {
                            name: 'contactPhone',
                            label: 'Contact Phone',
                            type: 'tel',
                            formatter: Formatters.phoneNumber,
                            required: true,
                        }, {
                            name: 'address1',
                            label: 'Address 1',
                            required: true,
                        }, {
                            name: 'address2',
                            label: 'Address 2',
                        }, {
                            name: 'city',
                            label: 'City',
                            required: true,
                        }, {
                            name: 'state',
                            label: 'State',
                            required: true,
                        }, {
                            name: 'zip',
                            label: 'Postal Code',
                            required: true,
                        }, {
                            name: 'country',
                            label: 'Country',
                            type: 'country',
                        }
                    ]
                },
                CallConfig: {
                    endpoint: '/callconfigs',
                },
                CallLog: {
                    endpoint: '/calllogs',
                    columns: [
                        {
                            name: 'fromPhone',
                            label: 'From',
                            renderer(value, row) {
                                let icon = 'fa-phone';
                                let title = 'Phone';
                                function linkTo(num) {
                                    if ([0, 1].includes(row.callSource)) {
                                        return `<a href data-prevent="callLogs.filterBy" data-filter="${num}">${num}</a>`;
                                    }
                                    return num;
                                }
                                if (row.callSource === 1) { icon = 'fa-sms'; title = 'SMS'; }
                                if (row.callSource === 2) { icon = 'fa-comments'; title = 'Web chat'; }
                                return `<fa class="${icon}" title="${title}"></fa> ${linkTo(value)}`;
                            }
                        }, {
                            name: 'toPhone',
                            label: 'To',
                            formatter: Formatters.phoneNumber,
                        }, {
                            name: 'createdAt',
                            label: 'Started',
                            type: datetime,
                            formatter: Formatters.localDateTime,
                        }, {
                            name: 'updatedAt',
                            label: 'Ended',
                            type: datetime,
                            formatter: Formatters.localDateTime,
                        }, {
                            name: 'messageCount',
                            label: 'Messages',
                            type: 'number',
                        }, {
                            name: 'guestCardCreated',
                            label: 'Guest Card',
                            renderer(value) {
                                switch (value) {
                                    case 1: return '<i class="fa fa-address-card" title="Created GC"></i>';
                                    case 2: return '<i class="fa fa-comment-sms" title="SMS Sent"></i>';
                                    case 4: return '<i class="fa fa-envelope" title="Email Sent"></i>';
                                    case 6: return '<i class="fa fa-comment-sms" title="SMS Sent"></i> <i class="fa fa-envelope" title="Email Sent"></i>';
                                    default: return '';
                                }
                            },
                        },
                    ]
                },
                GroupMember: {
                    endpoint: '/groupmembers',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name',
                            required: true
                        }, {
                            name: 'phoneNumber',
                            label: 'Phone Number',
                            type: 'tel',
                            required: true
                        }, {
                            name: 'isOwner',
                            label: 'Group Owner',
                            type: 'bool',
                            formatter: Formatters.yesno,
                        }
                    ],
                },
                PaymentMethod: {
                    endpoint: '/companies/payment/',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name on Card',
                            required: true,
                        }, {
                            name: 'cardNumber',
                            label: 'Card Number',
                            required: true,
                        }, {
                            name: 'expiration',
                            label: 'Expiration Date',
                            type: 'monthyear',
                            required: true,
                        }, {
                            name: 'cvv',
                            label: 'CVV',
                            type: 'number',
                            allowInput(event) {
                                return event.keyCode >= 48 && event.keyCode <= 57 && event.target.value.length < 4;
                            }
                        }, {
                            name: 'billingZip',
                            label: 'Zip Code',
                            type: 'number',
                        }
                    ]
                },
                TrainingData: {
                    endpoint: '/trainingdata',
                    columns: [
                        {
                            /*name: 'sequence',
                            label: 'Order',
                            type: 'number',
                            editable: false,
                            classes: 'text-end text-nowrap',
                        }, {*/
                            name: 'aiInstruction',
                            label: 'AI Instruction',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno
                        }, {
                            name: 'keyword',
                            label: 'Keyword',
                            type: 'text',
                            headerstyle: { 'min-width': '6em' },
                            hiddenWhen: (row) => row.aiInstruction,
                            sortable: false,
                        }, {
                            name: 'keywordTrigger',
                            label: 'Keyword Triggers Response',
                            type: 'bool',
                            hidden: inGrid,
                        }, {
                            name: 'prompt',
                            label: 'Prompt',
                            type: 'text',
                            headerstyle: { 'min-width': '6em' },
                            hiddenWhen: (row) => row.aiInstruction,
                            sortable: false,
                        }, {
                            name: 'text',
                            label: 'Text',
                            type: 'text',
                            sortable: false,
                        }, {
                            name: 'attachmentThumbnailUrl',
                            hidden: true,
                        }, {
                            name: 'attachmentUrl',
                            label: 'Attachment',
                            type: 'image',
                            onUploaded(model, response) {
                                model.attachmentThumbnailUrl = response.model.thumbUrl;
                            },
                            hidden: inGrid,
                        }, {
                            name: 'instantAnswer',
                            label: 'Instant answer',
                            headerLabel: 'IA',
                            headerAttr: { title: 'Instant answer' },
                            type: 'bool',
                            headerstyle: { 'min-width': '3em' },
                            hiddenWhen: (row) => row.aiInstruction,
                            formatter: Formatters.yesno,
                            sortable: false,
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            headerstyle: { 'min-width': '6em' },
                            sortable: false,
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            headerstyle: { 'min-width': '8em' },
                            sortable: false,
                        },
                    ],
                    tools: [
                        { id: 'up', click: this.trainingDataMove, classes: 'btn-outline-secondary text-primary', attr: { title: 'Move up' }, html: '<i class="fa fa-turn-up"></i>', on: 'row' },
                        { id: 'down', click: this.trainingDataMove, classes: 'btn-outline-secondary text-primary', attr: { title: 'Move down' }, html: '<i class="fa fa-turn-down"></i>', on: 'row' }
                    ]
                },
            };
        },
        computed: {
            embedCode() {
                const e = (c) => encodeURIComponent(c);
                const url = `https://${window.location.host}/webchat/script/${this.embed.id}?theme=${this.embedTheme}&color1=${e(this.embedColor1)}&color2=${e(this.embedColor2)}&open=${this.embedOpen}`;
                //The interpreter is super unhappy about seeing script tags in the middle here, so it's pre-encoded for safety.
                return `&lt;script async type="text/javascript" src="${url}"&gt;&lt;/script&gt;`;
            },
            hasInbox() {
                return !!this.callConfigs.find(c => c.featureInbox);
            },
            inboxes() {
                return this.callConfigs.filter(c => c.featureInbox);
            },
            paymentMethodDescription() {
                let d = this.paymentMethod.description || 'No information on file';
                return d.replaceAll('\n', '<br>');
            },
            tableClass() {
                return Prefs.theme.value ? 'table-dark' : '';
            },
            chatTheme() {
                return Prefs.theme.value ? '2' : '1';
            },
        },
        watch: {
            groupMembersFilter(value) {
                if (!value?.trim()) {
                    this.loadGroupMembers();
                }
            },
            inboxFilter(value) {
                if (!value?.trim()) {
                    this.loadInbox();
                }
            },
            notifications(value) {
                Prefs.notifications.value = value;
            },
            selectedInbox(value, oldValue) {
                if (value) {
                    this.selectedThread = null;
                    this.loadGroupMembers();
                    this.watchInbox(value.id);
                }
                this.unwatchInbox(oldValue?.id);
                this.loadInbox();
            },
            selectedCompanyId(value, oldValue) {
                const vm = this;
                let company = vm.companies.find(c => c.id === value);
                vm.company = company;
                vm.currentUser.roles.Owner = company.owner;
                vm.currentUser.roles.BillingAdmin = company.billingAdmin;
                vm.currentUser.roles.CompanyAdmin = company.companyAdmin;
                const params = { size: 100, page: 1, sort: 'inboxName', dir: 'asc', companyId: value, inbox: true };
                vm.loading = true;
                axios.get(vm.CallConfig.endpoint, { params })
                    .then(r => {
                        vm.selectedCallConfig = null;
                        vm.selectedInbox = (vm.inboxes.length == 1 ? vm.inboxes[0] : null);
                        vm.callConfigs = r.data.rows;
                        sessionStorage.selectedCompanyId = value;
                        vm.$refs.billingTab?.addEventListener('show.bs.tab', vm.getBilling);
                        vm.$nextTick(vm.selectTabInit);
                        if (value != oldValue && r.data.rows.find(c => c.featureInbox)) {
                            vm.loadInbox();
                            vm.watchInbox(value);
                            vm.unwatchInbox(oldValue);
                        }
                    })
                    .catch(e => {
                        window.location.reload();
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            embedOpen() {
                this.saveEmbedPrefs();
            },
            embedTheme() {
                this.saveEmbedPrefs();
            },
            embedColor1() {
                this.saveEmbedPrefs();
            },
            embedColor2() {
                this.saveEmbedPrefs();
            },
            title(title) {
                Events.send('settitle', title);
            }
        },
        created() {
            const vm = this;
            vm.notifications = Prefs.notifications.value;
            axios.get('/users/identity')
                .then(r => {
                    if (r.status === 200) {
                        Object.assign(vm.currentUser, r.data);
                        let id = sessionStorage.selectedCompanyId;
                        if (vm.companies && vm.companies.length) {
                            if (vm.companies.find(c => c.id === id)) {
                                vm.selectedCompanyId = id;
                            } else {
                                vm.selectedCompanyId = vm.companies[0].id;
                            }
                        }
                    }
                });
            vm.chatService = new signalR.HubConnectionBuilder()
                .withUrl('/hub')
                .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: retryContext => {
                        return (retryContext.elapsedMilliseconds < 60000) ? 10000 : null;
                    }
                })
                .build();
            vm.chatService.start().catch(console.log);
            vm.chatService.on('inbox', vm.refreshInbox);
            vm.chatService.onreconnecting(function () {
                console.log('disconnected');
            });
            vm.chatService.onreconnected(function () {
                if (vm.callConfigs.find(c => c.featureInbox)) {
                    vm.watchInbox(vm.selectedInbox?.id );
                    vm.watchInbox(vm.selectedCompanyId);
                }
            });
        },
        mounted() {
            const vm = this;
            document.querySelector('.nav-masthead > .container').appendChild(vm.$refs.navButton);
            const logo = document.querySelector('header h3');
            document.body.appendChild(vm.$refs.editBillingModal);
            document.body.appendChild(vm.$refs.editBusinessModal);
            document.body.appendChild(vm.$refs.editPaymentModal);
            document.addEventListener('resize', resize);
            function resize() {
                logo.style.width = vm.$refs.navLeft.width + 'px';
            }
            Events.on('callLogs.filterBy', (d) => {
                vm.$refs.callLogDataGrid.searchTerms = d.filter;
                d?.filter && vm.$refs.callLogDataGrid.getData();
            });
            setInterval(() => {
                vm.time = new Date().getTime();
                vm.connected = this.chatService?.state === signalR.HubConnectionState.Connected;
            }, 1000);
        },
        methods: {
            addGroupMember() {
                const vm = this;
                var model = vm.$refs.addGroupMemberForm.model;
                axios.post(vm.GroupMember.endpoint, model)
                    .then(r => {
                        if (r.data.message) {
                            return Events.send(Events.error, r.data.message);
                        }
                        vm.$refs.addGroupMemberDialog.hide();
                        vm.loadGroupMembers();
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    });
            },
            companyUserUrl(data) {
                if (data.name === 'delete') {
                    let id = data.item.id;
                    let companyId = data.item.companyId;
                    data.url = `${this.AppUser.endpoint}/${id}/${companyId}`;
                }
            },
            copyEmbed() {
                navigator.clipboard.writeText(this.embedCode
                    .replaceAll('&lt;', '<')
                    .replaceAll('&gt;', '>')
                    .replaceAll('&amp;', '&'));
            },
            dateDiff(d1, d2) {
                //comparing to the minute - 2023-05-11T02:03
                return d1.substring(0, 16) !== d2.substring(0, 16);
            },
            dateFormat(d) {
                return Formatters.localDateTime(d);
            },
            deleteGroupMember(member) {
                const vm = this;
                axios.delete(`${vm.GroupMember.endpoint}/${member.id}`)
                    .then(r => {
                        vm.loadGroupMembers();
                        vm.$refs.dialog.hide();
                    });
            },
            editBilling() {
                this.$refs.editBillingForm.model = _.cloneDeep(this.billingInfo);
                bootstrap.Modal.getOrCreateInstance(this.$refs.editBillingModal).show();
            },
            editBusiness() {
                this.$refs.editBusinessForm.model = _.cloneDeep(this.businessInfo);
                bootstrap.Modal.getOrCreateInstance(this.$refs.editBusinessModal).show();
            },
            editPayment() {
                this.$refs.editPaymentForm.model = _.cloneDeep(this.paymentMethod);
                bootstrap.Modal.getOrCreateInstance(this.$refs.editPaymentModal).show();
            },
            getBilling() {
                const vm = this;
                debounce('getBilling', () => {
                    axios.get(vm.BillingInfo.endpoint + vm.selectedCompanyId)
                        .then(r => {
                            vm.billingInfo = r.data.billingInfo;
                            vm.businessInfo = r.data.businessInfo;
                            vm.paymentMethod = r.data.paymentMethod;
                        })
                        .catch(r => {
                            Events.send(Events.error, r.data?.message);
                        });
                }, 100);
            },
            getLanguage(lang) {
                return PickList.languages.find(l => l.value === lang)?.text;
            },
            getUnread(data) {
                const vm = this;
                axios.get('/inbox/unread/' + data.id)
                    .then(r => {
                        r.data.forEach(d => {
                            let config = vm.callConfigs.find(cc => cc.id === d.id);
                            if (config) {
                                if (config.unreadCount < d.unreadCount) {
                                    vm.playNotification();
                                }
                                config.unreadCount = d.unreadCount;
                            }
                        })
                    });
            },
            infoBlock(bi) {
                return [bi.name,
                bi.description,
                Formatters.phoneNumber(bi.contactPhone),
                bi.address1,
                bi.address2,
                Formatters.commaSeparated(bi.city, bi.state, bi.zip),
                bi.country].filter(i => i)
                    .join('<br>') || 'No information on file';
            },
            isActive(value) {
                return value ? ' active' : '';
            },
            isBillingAdmin() {
                return this.isOwner() || this.currentUser.roles.BillingAdmin;
            },
            isCompanyAdmin() {
                return this.isOwner() || this.currentUser.roles.CompanyAdmin;
            },
            isOwner() {
                return this.currentUser.roles.Admin || this.currentUser.roles.Owner;
            },
            loadGroupMembers(search) {
                const vm = this;
                debounce('loadGroupMembers', () => {
                    vm.loading = true;
                    let params = { callConfigId: vm.selectedInbox.id, q: search };
                    vm.groupMembers = [];
                    axios.get(vm.GroupMember.endpoint, { params })
                        .then(r => {
                            vm.groupMembers = r.data.rows;
                        })
                        .finally(() => {
                            vm.loading = false;
                        });
                }, 100);
            },
            loadInbox(notify) {
                const vm = this;
                debounce('loadInbox', () => {
                    const params = {
                        size: 100,
                        page: 1,
                        sort: 'time',
                        q: vm.inboxFilter,
                        companyId: vm.selectedCompanyId,
                        callConfigId: vm.selectedInbox?.id,
                    };
                    vm.loading = true;
                    axios.get('/inbox', { params })
                        .then(i => {
                            let unreadCount = i.data.rows.filter(r => r.unread).length;
                            if (notify && vm.threads.filter(t => t.unread).length < unreadCount) {
                                if (vm.selectedInbox) {
                                    vm.selectedInbox.unreadCount = unreadCount;
                                }
                                vm.playNotification();
                            }
                            vm.threads = i.data.rows;
                            if (vm.selectedInbox?.featureGroupChat && i.data.rows.length) {
                                vm.$nextTick(() => {
                                    vm.selectThread(vm.threads[0])
                                });
                            }
                        })
                        .finally(() => {
                            vm.loading = false;
                        });
                }, 100);
            },
            onCallConfigSelected(c) {
                this.selectedCallConfig = c;
                this.selectedCallLogId = null;
            },
            onCallLogSelected(c) {
                const vm = this;
                this.selectedCallLogId = c.id;
                axios.get('/CallLogEntries', { params: { callLogId: c.id } })
                    .then(r => {
                        vm.messages = r.data.rows;
                    });
            },
            phoneNumber(number) {
                return Formatters.phoneNumber(number.number) + ' (' + this.getLanguage(number.language) + ')';
            },
            playNotification() {
                if (this.notifications) {
                    debounce('notify', () => {
                        notification.play();
                    }, 500);
                }
            },
            relativeDateTime(date) {
                return Formatters.relativeDateTime(date);
            },
            refreshInbox(inbox) {
                if (inbox.id === this.selectedInbox?.id) {
                    this.loadInbox(true);
                } else {
                    this.getUnread(inbox);
                }
            },
            retrain(prompt, response) {
                const vm = this;
                vm.$refs.trainingDataGrid.addDialog({
                    prompt: prompt.text,
                    text: response.text.replaceAll('<br/>', '\n'),
                });
            },
            saveEmbedPrefs() {
                let json = JSON.stringify({
                    embedOpen: this.embedOpen,
                    embedTheme: this.embedTheme,
                    embedColor1: this.embedColor1,
                    embedColor2: this.embedColor2,
                });
                localStorage.setItem(this.embed.id + '.embed', json);
            },
            saveNumbers(callConfig) {
                const vm = this;
                vm.loading = true;
                vm.callConfigNumbersErrors = {};
                axios.patch(`${vm.CallConfig.endpoint}/${callConfig.id}/Numbers`, callConfig.numbers)
                    .then(r => {
                        if (r.data.errors) {
                            vm.callConfigNumbersErrors = r.data.errors;
                        } else {
                            let config = vm.callConfigs.find(c => c.id === r.data.id);
                            config.numbers = r.data.numbers;
                            vm.$refs.callConfigNumbersForm?.success();
                        }
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            saveSettings(callConfig) {
                const vm = this;
                vm.loading = true;
                vm.callConfigSettingsErrors = {};
                axios.patch(`${vm.CallConfig.endpoint}/${callConfig.id}`, callConfig)
                    .then(r => {
                        if (r.data.errors) {
                            vm.callConfigSettingsErrors = r.data.errors;
                        } else {
                            let config = vm.callConfigs.find(c => c.id === r.data.id);
                            Object.assign(config, r.data);
                            vm.$refs.callConfigSettingsForm?.success();
                        }
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            searchInbox() {
                this.loadInbox();
            },
            searchGroupChat() {
                this.loadGroupMembers(this.groupMembersFilter);
            },
            selectTab(event, inbox) {
                if (!event.target) { return; }
                const target = event.target;
                const tabid = target.getAttribute('aria-controls');
                target.classList.add('active');
                target.ariaSelected = true;
                this.title = target.title;
                this.$el.querySelectorAll('[role="tab"]').forEach(t => {
                    if (t.id != target.id) {
                        t.classList.remove('active');
                        t.ariaSelected = false;
                    }
                });
                this.$el.querySelectorAll('[role="tabpanel"]').forEach(t => {
                    if (t.id != tabid) {
                        t.classList.remove('active');
                        t.classList.remove('show');
                        t.ariaSelected = false;
                    } else {
                        t.classList.add('active');
                        t.classList.add('show');
                        t.ariaSelected = true;
                    }
                });
                this.mobileNavShow = false;
                this.selectedInbox = inbox ?? (this.inboxes.length == 1 ? this.inboxes[0] : this.inboxes.find(i => i.featureGroupChat));
                this.selectedCallConfig = null;
            },
            selectTabInit() {
                let target = this.$refs.inboxTab ?? this.$refs.callConfigsTab;
                if (target)
                    this.selectTab({ target });
                else
                    setTimeout(this.selectTabInit, 10);
            },
            selectThread(thread) {
                const vm = this;
                axios.post('/inbox/read', { id: thread.id })
                    .then(r => {
                        let config = r.data?.id ? vm.callConfigs.find(c => c.id == r.data.id) : null;
                        if (config) config.unreadCount = r.data.unreadCount;
                    });
                thread.unread = false;
                this.selectedThread = thread;
            },
            showAddGroupMember() {
                const vm = this;
                vm.$refs.addGroupMemberForm.model = {
                    callConfigId: vm.selectedInbox.id,
                    enabled: true,
                    isOwner: false,
                    name: '',
                    phoneNumber: '',
                };
                vm.$refs.addGroupMemberDialog.show();
            },
            showDeleteGroupMember(member) {
                const vm = this;
                let title = 'Remove Group Member';
                if (member.isOwner) {
                    vm.$refs.dialog.show({
                        title,
                        body: `Sorry, you cannot remove a group owner.`,
                        buttons: [ { id: 'ok', html: 'OK', classes: 'btn-primary', dismiss: true } ]
                    });
                    return;
                }
                vm.$refs.dialog.show({
                    title,
                    body: `Are you sure you want to remove <b>${member.name}</b>?`,
                    buttons: [
                        { id: 'cancel', html: 'Cancel', classes: 'btn-default', dismiss: true },
                        { id: 'ok', html: 'Remove', classes: 'btn-danger', click() { vm.deleteGroupMember(member); } }
                    ]
                });
            },
            showEmbedDialog(phone) {
                this.embed = phone;
                let json = localStorage.getItem(phone.id + '.embed');
                let old = {};
                if (json) {
                    try {
                        old = JSON.parse(json);
                    } catch (_) { }
                }
                this.embedOpen = old?.embedOpen || this.embedOpen;
                this.embedTheme = old?.embedTheme || this.embedTheme;
                this.embedColor1 = old?.embedColor1 || this.embedColor1;
                this.embedColor2 = old?.embedColor2 || this.embedColor2;
                this.$refs.embedDialog.show({ buttons: [{ id: 'ok', html: 'OK', classes: 'btn-primary', dismiss: true }] });
            },
            submitBilling() {
                const vm = this;
                vm.loading = true;
                const model = this.$refs.editBillingForm.model;
                axios.post(vm.BillingInfo.endpoint, model)
                    .then(r => {
                        vm.billingInfo = r.data;
                        bootstrap.Modal.getInstance(vm.$refs.editBillingModal).hide();
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            submitBusiness() {
                const vm = this;
                vm.loading = true;
                const model = this.$refs.editBusinessForm.model;
                axios.post('/companies/business', model)
                    .then(r => {
                        vm.businessInfo = r.data;
                        bootstrap.Modal.getInstance(vm.$refs.editBusinessModal).hide();
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            submitPayment() {
                const vm = this;
                vm.loading = true;
                const model = this.$refs.editPaymentForm.model;
                model.cvv = '' + model.cvv;
                model.billingZip = '' + model.billingZip;
                axios.post(vm.PaymentMethod.endpoint, model)
                    .then(r => {
                        vm.paymentMethod = r.data;
                        bootstrap.Modal.getInstance(vm.$refs.editPaymentModal).hide();
                    })
                    .catch(e => {
                        Events.send(Events.error, e);
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            toggleAnswerMode() {
                if (this.selectedInbox) {
                    const vm = this;
                    const answerMode = !vm.selectedInbox.answerMode;
                    vm.selectedInbox.answerMode = answerMode;
                    axios.post(vm.CallConfig.endpoint + '/AnswerMode', { id: vm.selectedInbox.id, answerMode })
                        .then(() => {
                            const el = vm.$refs.answerModeToggle;
                            const popover = new bootstrap.Popover(el, {
                                trigger: 'focus',
                                content: answerMode
                                    ? 'In this mode the AI will make suggestions that a user approves or edits before sending.'
                                    : 'In this mode the AI will automatically answer every incoming message.'
                            });
                            popover.show();
                            el.addEventListener('hidden.bs.popover', () => {
                                popover.dispose();
                            });
                            setTimeout(() => { popover.hide(); }, 5000);
                        });
                }
            },
            toggleGroupMemberEnabled(member) {
                const vm = this;
                axios.post(`${vm.GroupMember.endpoint}/enable/${member.id}`)
                    .then(r => {
                        if (r.status === 200) {
                            member.enabled = r.data.model.enabled;
                        }
                    }).catch(e => {
                        Events.send(Events.error, e);
                    });
            },
            toggleGroupMemberOwner(member) {
                const vm = this;
                axios.post(`${vm.GroupMember.endpoint}/owner/${member.id}`)
                    .then(r => {
                        if (r.status === 200) {
                            member.isOwner = r.data.model.isOwner;
                        }
                    }).catch(e => {
                        Events.send(Events.error, e);
                    });
            },
            toggleNav() {
                this.mobileNavShow = !this.mobileNavShow;
            },
            trainingDataMove(row, dir) {
                const vm = this;
                axios.patch(`${vm.TrainingData.endpoint}/${dir}/${row.id}`)
                    .then(r => {
                        if (r.status === 200) {
                            vm.$refs.trainingDataGrid.getData(null, true);
                        }
                    }).catch(e => {
                        Events.send(Events.error, e);
                    });
            },
            unwatchInbox(id) {
                if (!id) return;
                const vm = this;
                if (!vm.connected) {
                    return debounce('unwatch', () => {
                        vm.unwatchInbox(id);
                    })
                }
                if (id && vm.chatService) {
                    vm.chatService.invoke('leave', {
                        connectionId: vm.chatService.connectionId,
                        id: id
                    });
                }
            },
            watchInbox(id) {
                if (!id) return;
                const vm = this;
                if (!vm.connected) {
                    return debounce('watch', () => {
                        vm.watchInbox(id);
                    })
                }
                if (vm.chatService) {
                    vm.chatService.invoke('join', {
                        connectionId: vm.chatService.connectionId,
                        id: id
                    });
                }
            }
        }
    }
</script>